import { ShipmentBoxModel } from '../../../../modules/warehouse-management/features/shipment-boxes/models/shipment-box.model';
import { TransferDispatchBoxAllocationResponse } from './transfer-dispatchbox-allocation.model';

// Paged response wrapper
export class TransferDispatchBoxPagedResponse {
  totalCount: number = 0;
  pageNumber: number = 0;
  pageSize: number = 0;
  items: TransferDispatchBoxResponse[] = [];
}

export abstract class TransferDispatchBoxModel {
  id: number = 0;
  shipmentBoxId: number = 0;
  transferDispatchOrderId: number = 0;
  trackingId: string = '';
  name: string = '';
  workDuration?: number = 0;
}

export class TransferDispatchBoxResponse extends TransferDispatchBoxModel {
  transferDispatchBoxAllocations: TransferDispatchBoxAllocationResponse[] = [];
  shipmentBox: ShipmentBoxModel = new ShipmentBoxModel();
}

export class TransferDispatchBoxCommand extends TransferDispatchBoxModel {}
